import { meilisearchClient } from '../search/meilisearch';
import { StrapiSiteConfig } from '../models/strapi-site-config.model';
import { Logger } from '../logger/Logger';
import { SortOrder } from '../../constants/SortOrder';

export async function getVendor(vendorId: number): Promise<any> {
  try {
    if (vendorId) {
      const res = await meilisearchClient.index(`vendor`).search(``, {
        filter: `id=${vendorId}`
      });

      return Promise.resolve(res);
    }

    return Promise.reject();
  } catch {
    return Promise.reject();
  }
}

const getSiteConfig = async (siteConfigId: number) => {
  try {
    if (siteConfigId) {
      const res = await meilisearchClient.index(`site-config`).search<StrapiSiteConfig>(``, {
        filter: `id=${siteConfigId}`,
        sort: [SortOrder.sortOrderAsc]
      });

      if (res.hits.length === 0) {
        return Promise.reject(new Error('SiteConfig not found'));
      }

      return Promise.resolve(res.hits[0]);
    }

    Logger.error('SiteConfig ID missing');

    return Promise.reject(new Error('SiteConfig ID missing'));
  } catch (error) {
    Logger.error(error);
    return Promise.reject();
  }
};

export { getSiteConfig };
